
import { Component, OnInit } from '@angular/core';
import { RdsAvatarModule, RdsButtonModule, RdsIconsModule, RdsMenuModule, RdsTooltipModule, RdsSwitchModule } from '@rds/angular-components';
import { User } from '../../models/user.model';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { CongressViewPreferenceService, CongressViewMode } from '../../services/congress-view-preference.service';


@Component({
  selector: 'app-user-info',
  standalone: true,
  imports: [
    RdsAvatarModule,
    RdsButtonModule,
    RdsIconsModule,
    RdsMenuModule,
    RdsTooltipModule,
    RdsSwitchModule,
],
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {
  user?: User;
  imgError = false;
  congressDrawerEnabled = true;

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private congressViewPreference: CongressViewPreferenceService,
  ) {
    this.congressDrawerEnabled = this.congressViewPreference.mode === 'drawer';
  }

  ngOnInit() {
    this.userService.getUserData().then((userData: User) => {
      this.user = userData;
      this.user.initials = this.user.displayName.split(' ').map(n => n[0].toUpperCase()).join('')
    }).catch((error: any) => {
      console.error('Failed to fetch user data:', error);
    });
  } 

  onCongressViewModeChange(checked: boolean) {
    const mode: CongressViewMode = checked ? 'drawer' : 'expand';
    this.congressViewPreference.setMode(mode);
    this.congressDrawerEnabled = checked;
  }

  logout() {
    this.authService.logout()
  }
}
